import {
  RECEIVE_DATA,
  INVALIDATE_CACHE,
  REQUEST_DATA,
  STAGE_WHAT_IFS,
  SET_UPDATE_CACHE_DATA,
  FAILED_TO_RECEIVE_DATA,
} from './MonteCarloChartActions';
import { MESSAGES } from '../CommonConstants';

const INITIAL_STATE = {};

export default (state = INITIAL_STATE, action) => {
  const { type, clientId, requestedWith, whatIfs, data, updateCacheData } = action;

  switch (type) {
    case REQUEST_DATA: {
      return {
        ...state,
        [clientId]: {
          ...(state[clientId] || {}),
          requestedWith,
          loading: ((state[clientId] || {}).loading || 0) + 1,
          error: null,
        },
      };
    }

    case INVALIDATE_CACHE:
      return {
        ...state,
        [clientId]: {
          ...(state[clientId] || {}),
          requestedWith: null,
          stagedWhatIfs: null,
        },
      };

    case STAGE_WHAT_IFS:
      return {
        ...state,
        [clientId]: {
          ...(state[clientId] || {}),
          stagedWhatIfs: whatIfs,
        },
      };

    case RECEIVE_DATA: {
      const clientState = state[clientId] || {};
      const loading = Math.max((clientState.loading || 1) - 1, 0);
      const hasError = Boolean(clientState.error);
      return {
        ...state,
        [clientId]: {
          ...clientState,
          responseData: loading === 0 && !hasError ? data : clientState.responseData,
          loading,
          error: clientState.error || null,
        },
      };
    }

    case SET_UPDATE_CACHE_DATA:
      return {
        ...state,
        [clientId]: {
          ...(state[clientId] || {}),
          updateCacheData,
        },
      };

    case FAILED_TO_RECEIVE_DATA: {
      const clientState = state[clientId] || {};
      const loading = Math.max((clientState.loading || 1) - 1, 0);
      return {
        ...state,
        [clientId]: {
          ...clientState,
          loading,
          error: MESSAGES.GENERIC_ERROR,
        },
      };
    }

    default:
      return state;
  }
};
